export const USER_DETAILS_FETCHING = 'API/USER_DETAILS_FETCHING';
export const USER_DETAILS_SUCCESS = 'API/USER_DETAILS_SUCCESS';
export const USER_DETAILS_FAILED = 'API/USER_DETAILS_FAILED';

export const LOGOUT_FETCHING = 'API/LOGOUT_FETCHING';
export const LOGOUT_SUCCESS = 'API/LOGOUT_SUCCESS';
export const LOGOUT_FAILED = 'API/LOGOUT_FAILED';

export const LINEUPS_FETCHING = 'API/LINEUPS_FETCHING';
export const LINEUPS_SUCCESS = 'API/LINEUPS_SUCCESS';
export const LINEUPS_FAILED = 'API/LINEUPS_FAILED';

export const SPORTS_FETCHING = 'API/SPORTS_FETCHING';
export const SPORTS_SUCCESS = 'API/SPORTS_SUCCESS';
export const SPORTS_FAILED = 'API/SPORTS_FAILED';

export const SOURCES_FETCHING = 'API/SOURCES_FETCHING';
export const SOURCES_SUCCESS = 'API/SOURCES_SUCCESS';
export const SOURCES_FAILED = 'API/SOURCES_FAILED';

export const SLATES_FETCHING = 'API/SLATES_FETCHING';
export const SLATES_SUCCESS = 'API/SLATES_SUCCESS';
export const SLATES_FAILED = 'API/SLATES_FAILED';
export const SLATES_SET_SELECTED = 'API/SLATES_SET_SELECTED';

export const ROSTER_FETCHING = 'API/ROSTER_FETCHING';
export const ROSTER_SUCCESS = 'API/ROSTER_SUCCESS';
export const ROSTER_FAILED = 'API/ROSTER_FAILED';

export const PLAYER_DETAILS_FETCHING = 'API/PLAYER_DETAILS_FETCHING';
export const PLAYER_DETAILS_SUCCESS = 'API/PLAYER_DETAILS_SUCCESS';
export const PLAYER_DETAILS_FAILED = 'API/PLAYER_DETAILS_FAILED';

export const GAMELOGS_FETCHING = 'API/GAMELOGS_FETCHING';
export const GAMELOGS_SUCCESS = 'API/GAMELOGS_SUCCESS';
export const GAMELOGS_FAILED = 'API/GAMELOGS_FAILED';

export const PLAYER_NEWS_FETCHING = 'API/PLAYER_NEWS_FETCHING';
export const PLAYER_NEWS_SUCCESS = 'API/PLAYER_NEWS_SUCCESS';
export const PLAYER_NEWS_FAILED = 'API/PLAYER_NEWS_FAILED';

export const ARTICLES_FETCHING = 'API/ARTICLES_FETCHING';
export const ARTICLES_SUCCESS = 'API/ARTICLES_SUCCESS';
export const ARTICLES_FAILED = 'API/ARTICLES_FAILED';

export const PROPS_ACTIVE_SPORT_CHANGED = 'INFO/PROPS_ACTIVE_SPORT_CHANGED';
export const PROPS_FETCHING = 'API/PROPS_FETCHING';
export const PROPS_SUCCESS = 'API/PROPS_SUCCESS';
export const PROPS_FAILED = 'API/PROPS_FAILED';

export const SPORTEVENTS_FETCHING = 'API/SPORTEVENTS_FETCHING';
export const SPORTEVENTS_SUCCESS = 'API/SPORTEVENTS_SUCCESS';
export const SPORTEVENTS_FAILED = 'API/SPORTEVENTS_FAILED';

export const PROPSRESULTS_ACTIVE_SPORT_CHANGED = 'INFO/PROPSRESULTS_ACTIVE_SPORT_CHANGED';
export const PROPSRESULTS_FETCHING = 'API/PROPSRESULTS_FETCHING';
export const PROPSRESULTS_SUCCESS = 'API/PROPSRESULTS_SUCCESS';
export const PROPSRESULTS_FAILED = 'API/PROPSRESULTS_FAILED';

export const TEAMS_FETCHING = 'API/TEAMS_FETCHING';
export const TEAMS_SUCCESS = 'API/TEAMS_SUCCESS';
export const TEAMS_FAILED = 'API/TEAMS_FAILED';

// export const CONTESTS_FETCHING = 'API/CONTESTS_FETCHING';
// export const CONTESTS_SUCCESS = 'API/CONTESTS_SUCCESS';
// export const CONTESTS_FAILED = 'API/CONTESTS_FAILED';
//
// export const CONTEST_PLAYERS_FETCHING = 'API/CONTEST_PLAYERS_FETCHING';
// export const CONTEST_PLAYERS_SUCCESS = 'API/CONTEST_PLAYERS_SUCCESS';
// export const CONTEST_PLAYERS_FAILED = 'API/CONTEST_PLAYERS_FAILED';
//
// export const CONTEST_USERS_FETCHING = 'API/CONTEST_USERS_FETCHING';
// export const CONTEST_USERS_SUCCESS = 'API/CONTEST_USERS_SUCCESS';
// export const CONTEST_USERS_FAILED = 'API/CONTEST_USERS_FAILED';
//
// export const CONTEST_LEADERBOARD_FETCHING = 'API/CONTEST_LEADERBOARD_FETCHING';
// export const CONTEST_LEADERBOARD_SUCCESS = 'API/CONTEST_LEADERBOARD_SUCCESS';
// export const CONTEST_LEADERBOARD_FAILED = 'API/CONTEST_LEADERBOARD_FAILED';
//
// export const CONTEST_OWNER_LINEUPS_FETCHING = 'API/CONTEST_OWNER_LINEUPS_FETCHING';
// export const CONTEST_OWNER_LINEUPS_SUCCESS = 'API/CONTEST_OWNER_LINEUPS_SUCCESS';
// export const CONTEST_OWNER_LINEUPS_FAILED = 'API/CONTEST_OWNER_LINEUPS_FAILED';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js